import { configureStore, createSlice } from '@reduxjs/toolkit';
import menuReducer from './menuSlice';
import usersReducer from './userTabSlice';
import tokensReducer from './tokensSlice';
import sportsReducer from './sportsTabSlice';
import notificationsReducer from './notificartionsTabSlice';
import opinionsReducer from './opinionsTabSlice';
import opinionsTTabReducer from './opinionsTTabSlice';
import opinionsUTabReducer from './opinionsUTabSlice';
import trainingsReducer from './trainingsTabSlice';
import statsReducer from './statsTabSlice';
import faqReducer from './faqTabSlice';
import userReportsReducer from './userReportsTabSlice';

const store = configureStore({
  reducer: {
    menu: menuReducer,
    users: usersReducer,
    tokens: tokensReducer,
    sports: sportsReducer,
    notifications: notificationsReducer,
    opinions: opinionsReducer,
    opinionsT: opinionsTTabReducer,
    opinionsU: opinionsUTabReducer,
    trainings: trainingsReducer,
    stats: statsReducer,
    faq: faqReducer,
    userReports: userReportsReducer,
    }});

export default store;
